import React from 'react'

import { SubjectWorkspaceLogo } from './InboxListItemPreview.styles'

interface WorkspacePreviewProps {
  name?: string
  src?: string | null
}

export const WorkspacePreview = ({ name, src }: WorkspacePreviewProps) => (
  <SubjectWorkspaceLogo size="32px" workspaceName={name} src={src} />
)
